export default __webpack_public_path__ + "static/media/advantage2.e79690e0.png";